export const PointCdek = () => (
	<svg width="50" height="58" viewBox="0 0 50 58" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_dd_25188_21663)">
			<path
				d="M40 19.75C40 32.6875 25 40 25 40C25 40 10 32.4062 10 19.75C10 11.0515 16.7157 4 25 4C33.2843 4 40 11.0515 40 19.75Z"
				fill="#1AB248"
			/>
		</g>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.0035 23.3825H23.7482C20.23 23.3825 22.786 15.6331 25.7479 15.6331H29.3113C29.8826 15.6331 30.8899 15.7422 31.3861 14.2765L32.1529 12H27.2664C24.6203 12 22.5604 12.9667 21.0719 14.5884C18.5009 17.3638 17.6289 21.6986 18.2453 23.7724C18.8317 25.6902 20.4254 26.9532 22.9213 26.9844L24.8608 27H27.2514L27.8378 25.1757C28.2738 23.8815 27.2965 23.3825 26.0035 23.3825Z"
			fill="white"
		/>
		<defs>
			<filter
				id="filter0_dd_25188_21663"
				x="0"
				y="0"
				width="50"
				height="58"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21663" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21663" result="effect2_dropShadow_25188_21663" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_25188_21663" result="shape" />
			</filter>
		</defs>
	</svg>
)
